import * as PIXI from 'pixi.js';
const CARD_PADDING_PX = 1;
const CARD_HEIGHT_PX = 25;
const MAX_CARD_CONTAINER_WIDTH_PX = 50;
export function getPlayerBubbleProperties(playerBubble, textStyle, bubbleWidth) {
    let totalH = 0;
    let prevY = 0;
    const { lines } = playerBubble;
    const lineProperties = lines.map((line) => {
        if (typeof line === 'string') {
            const textMetrics = PIXI.TextMetrics.measureText(line, textStyle);
            totalH += textMetrics.height;
            const currY = Math.round(textMetrics.height / 2) + prevY;
            prevY += textMetrics.height;
            return {
                type: 'text',
                text: line,
                bounds: { x: Math.round(bubbleWidth / 2), y: currY, w: bubbleWidth, h: textMetrics.height }
            };
        }
        else {
            // line is Card[]
            const cards = line;
            const cardContainerWidthPx = Math.min(MAX_CARD_CONTAINER_WIDTH_PX, Math.round(bubbleWidth / 2));
            const cardWidthPx = cardContainerWidthPx - CARD_PADDING_PX * 2;
            const centerX = Math.round(bubbleWidth / 2);
            const numCardsPerRow = cards.length > 2 && bubbleWidth >= MAX_CARD_CONTAINER_WIDTH_PX * 4 ? 4 : 2;
            const leftmostCardContainerX = centerX - (numCardsPerRow / 2) * cardContainerWidthPx;
            const cardsWithBounds = cards.map((card, i) => {
                const colIndex = i % numCardsPerRow;
                const rowIndex = Math.floor(i / numCardsPerRow);
                const bounds = {
                    x: leftmostCardContainerX + colIndex * cardContainerWidthPx + CARD_PADDING_PX,
                    y: prevY + CARD_PADDING_PX + rowIndex * CARD_HEIGHT_PX,
                    w: cardWidthPx,
                    h: CARD_HEIGHT_PX - CARD_PADDING_PX * 2
                };
                return { card, bounds };
            });
            const numRows = Math.ceil(cards.length / numCardsPerRow);
            const lineTotalHeight = numRows * CARD_HEIGHT_PX;
            totalH += lineTotalHeight;
            prevY += lineTotalHeight;
            return {
                type: 'cards',
                cardsWithBounds
            };
        }
    });
    const dimensions = { w: bubbleWidth, h: totalH };
    return { dimensions, lineProperties };
}
